"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportAdBind = reportAdBind;
exports.reportAdCreate = reportAdCreate;
exports.reportAdDelete = reportAdDelete;
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】广告管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：创建/删除/绑定广告
 */

/**
 * 创建广告埋点上报
 * @param {Object} adInfo - 广告信息
 */
function reportAdCreate(adInfo) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '创建广告',
    content: "\u521B\u5EFA\u5E7F\u544A\u300C".concat(adInfo.title, "\u300D\uFF0C\u4F4D\u7F6E\uFF1A").concat(adInfo.position),
    operation_id: 'pc_ad_create_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_ad_create_1');
}

/**
 * 删除广告埋点上报
 * @param {number} adId - 广告ID
 * @param {string} adTitle - 广告标题
 */
function reportAdDelete(adId, adTitle) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '删除广告',
    content: "\u5220\u9664\u5E7F\u544A\u300C".concat(adTitle, "\u300D(ID:").concat(adId, ")"),
    operation_id: 'pc_ad_delete_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_ad_delete_1');
}

/**
 * 绑定广告到设备埋点上报
 * @param {number} adId - 广告ID
 * @param {Array} snList - 设备SN码列表
 */
function reportAdBind(adId, snList) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '绑定广告',
    content: "\u5C06\u5E7F\u544AID:".concat(adId, " \u7ED1\u5B9A\u5230 ").concat(snList.length, " \u53F0\u8BBE\u5907"),
    operation_id: 'pc_ad_bind_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_ad_bind_1');
}